import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { EMPTY_ARRAY } from "@client/lib/array";
import { getMultiselectValue } from "@client/lib/settings";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState, type OptionItem } from "@client/types";
import { isNull } from "lodash";
import { connect } from "react-redux";
import { localStateSelector } from "../../selectors";
import { type Checkout } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  addressType: "billing" | "shipping";
  isSameAsShipping: boolean | null;
  onChange: (name: string, value: any) => void;
  order: Checkout.Order;
  onRegionsLoaded: (options: OptionItem<string>[]) => void;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "billingItems", converter: getMultiselectValue, prop: "billingItems" },
    { name: "shippingItems", converter: getMultiselectValue, prop: "shippingItems" },
    "stackFields"
  ]);

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const settings = settingsSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      excludeFields: isNull(props.isSameAsShipping) ? EMPTY_ARRAY : localState.excludeFields,
      isVisible: !isNull(props.isSameAsShipping) || localState.cart.requiresShipping,
      items: isNull(props.isSameAsShipping) ? settings.shippingItems : settings.billingItems,
      requiresShipping: localState.cart.requiresShipping,
      shouldStackFields: settings.stackFields
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChange: props.onChange,
  onRegionsLoaded: props.onRegionsLoaded
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
